module.exports = __webpack_public_path__ + "static/media/arrow-right.e9bc8e66.svg";